<style scoped>
 .v-text-field >>> .v-select__selection {
   font-size: 0.8em;
 }
 div.combobox-block-00 {
   padding: 5px;
 }
 .v-text-field >>> label {
   font-size: 0.8em;
 }
 .v-text-field >>> button {
   font-size: 0.2em;
 }
 .select-top-margin {
   margin-top: 15px;
 }
 .label-title-00.sm-text {
   font-size: 10px;
 }
</style>
<template>
  <div class="container-00">

    <div class="osc-block-00 osc-border-00 card-00">
      <div class="card-title-00">
        {{ parameter_group_title }} &nbsp;
        <v-btn x-small icon v-on:click="dump_common_param()"><v-icon>mdi-text-box-outline</v-icon></v-btn>
      </div>

      <!-- --------------------- -->
      <div class="select-block-00">
        <div class="combobox-block-00 select-top-margin">
          <v-select
              v-model="common_param.keyTrigger"
              v-on:change="onUpdateParam('keyTrigger', $event)"
              :background-color="v_select_background_color"
              :items="keyTrigger_items"
              item-text="text"
              item-value="id"
              label="KEY TRIGGER"
              menu-props="auto, overflowY"
              outlined
              hide-details
              dense
          ></v-select>
        </div>
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center"><div class="label-title-00 sm-text">OCT BTN</div><div>LEVEL</div></div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="common_param.octaveLevel" v-on:change="onUpdateParam('octaveLevel', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Octave Voice Level<br/>%d %"></webaudio-knob></div>
          </div>
        </div>
      </div>

      <!-- --------------------- -->
      <div class="knob-block-00 common-border-01">
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center"><div class="label-title-00">BEND</div><div>RANGE</div></div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="12"  :value="common_param.bendRange" v-on:change="onUpdateParam('bendRange', $event.target.value)" conv="x" tooltip="Bend Range<br/>%s semitones"></webaudio-knob></div>
          </div>
        </div>
        <div class="slider-00-child-00">
          <div class="slider-label-00 justify-align-center">STEP</div>
          <div class="knob-ctrl-00"><webaudio-switch id="sw1" colors="#0f0;#fff;#fff" :value="common_param.bendStepmode" v-on:change="onUpdateParam('bendStepMode', $event.target.value)"></webaudio-switch></div>
        </div>
      </div>

      <!-- --------------------- -->
      <div class="knob-block-00 common-border-01">
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center"><div class="label-title-00">VIBTATO</div><div>PITCH</div></div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="common_param.biteVibrato" v-on:change="onUpdateParam('biteVibrato', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Pitch Vibrato Amount<br/>%d %"></webaudio-knob></div>
          </div>
        </div>
        <div class="knob-00-parent">
          <div class="knob-00-child-00 justify-align-center">
            <div class="knob-label-00">AMP</div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="common_param.biteTremolo" v-on:change="onUpdateParam('biteTremolo', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Amp Vibrato Amount<br/>%d %"></webaudio-knob></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
 export default {
   name: 'Common',
   props: [ 'parameter_group_title', 'label', 'keyTrigger_items', 'commonparam'],
   methods: {
     dump_common_param: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       console.log(`[store:${this.label}]`, workingPatch.decoded)
       console.log(`[local:${this.label}]`, this.$data.common_param)
     },
     onUpdateParam: function(key, val) {
       //console.log(this.formant_param, key, val, this.$data)
       //const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       //const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       //console.log(this.label, workingPatch)
       this.$set(this.$data.common_param, key, val)
       this.$store.commit('onEditOneEditPatch', {arr_idx: [key], value: Uint8Array.from([val])})

       // let PatchNumNameCard component to recognise params change
       this.$router.app.$children[0].updateParamIsSyncedApp()
     }
   },
   created: function() {
     console.log(`<CREATED> label=[${this.label}]`)
     Object.keys(this.commonparam).forEach( key => {
       this.$data.common_param[key] = this.commonparam[key]
       console.log(`key=[${key}] val=[${this.commonparam[key]}]`)
     })
   },
   computed: {
     testCount: {
       get () {
         return this.$store.getters.getTestCount()
       },
       //set (value) {
       //this.$store.commit('onTestChange', value)
       //}
     }
   },
   data: () => ({
     v_select_background_color: '#fffef2',
     common_param: {
       keyTrigger: 0,
       octaveLevel: 20,
       bendRange: 50,
       bendStepMode: 0,
       biteVibrato: 50, // VIBRATO:PITCH
       biteTremolo: 55, // VIBRATO:AMP
     }
   })
 }
</script>
